<template>
  <div>
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.usersTotal | numberDisplay }}</strong> users</p>
        </div>

        <div class="level-item">
          <div class="field has-addons">
            <div class="control">
              <input v-model="searchValue" class="input" type="text" placeholder="Find by" v-on:keyup.enter="searchUsers">
            </div>
            <div class="control">
              <span class="select">
                <select v-model="searchKey">
                  <option value="name">name</option>
                  <option value="email">email</option>
                </select>
              </span>
            </div>
            <div class="control">
              <button class="button is-primary" v-on:click="searchUsers">Search</button>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Email</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.users.length">
          <td colspan="5" class="has-text-centered has-text-grey">No users found</td>
        </tr>
        <tr v-for="item in this.$store.state.users">
          <td>{{ item.id }}</td>
          <td><router-link v-bind:to="`/users/${item.id}`">{{ item.name || 'No name' }}</router-link></td>
          <td>
            <span v-if="item.verified === true" class="icon has-text-success tooltip" data-tooltip="Email is confirmed"><i class="fa fa-check-circle"></i></span>
            <span v-else class="icon has-text-warning tooltip" data-tooltip="Email is not confirmed"><i class="fa fa-exclamation-circle"></i></span>
            {{ item.email }}
          </td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    data () {
      return {
        searchValue: this.$route.query.name ||
          this.$route.query.email ||
          '',
        searchKey: this.$route.query.name ? 'name'
          : this.$route.query.email ? 'email'
          : 'name',

        searchParams: {}
      }
    },

    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.usersTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      },

      searchUsers () {
        this.searchParams[this.searchKey] = this.searchValue
        this.searchParams.created_after = this.createdAfter
        this.searchParams.created_before = this.createdBefore

        // Clean empty fields
        Object.keys(this.searchParams)
          .filter(key => !this.searchParams[key])
          .forEach(key => delete this.searchParams[key])

        this.$router.push({
          path: `/users`,
          query: this.searchParams
        })
      }
    },

    created () {
      this.$store.dispatch('getOrganizationUsers', {
        organizationId: this.$store.state.organizationId,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getOrganizationUsers', {
          organizationId: this.$store.state.organizationId,
          params: this.$route.query
        })
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// UserList.vue?d134066c